/// <reference types="vite-plugin-svgr/client" />
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./index.css";
import App from "./App";
import { store } from "./redux-store";
import * as Sentry from "@sentry/react";
import { loadMapsApiKeys } from "./ducks/app/maps-api-keys";

// This is needed to initialize i18next
import "./i18n";

Sentry.init({
  dsn: "https://dc3a4129513771e851dcc220a42b9261@o4507542742368256.ingest.de.sentry.io/4507542783131728",
  sendDefaultPii: true, // Enable IP address collection
  // No `tracePropagationTargets`: the default attaches trace headers to same-origin
  // requests, linking these traces to the server's.
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions, reduce in production!
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  enabled: process.env.NODE_ENV !== "development",
});

store.dispatch(loadMapsApiKeys());

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
